import { render, staticRenderFns } from "./rightPanel.vue?vue&type=template&id=9f899946"
import script from "./rightPanel.vue?vue&type=script&lang=js"
export * from "./rightPanel.vue?vue&type=script&lang=js"
import style0 from "./rightPanel.vue?vue&type=style&index=0&id=9f899946&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports